export default {
  authenticate() {
    const token = sessionStorage.getItem("userToken");
    if (token) {
      return true;
    }
    return false;
  },
};